import { useState } from 'react';
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import { useMutation } from '../../hooks/useApi';
import { routes } from '../../api/routes';
import { useSession } from '../../session/SessionContext';
import { Card, Field } from '../../components/ui';
import { InlineError } from '../../components/ErrorView';

/** Email verification. The token may arrive in the link or be typed from the mail. */
export function Verify() {
  const [params] = useSearchParams();
  const nav = useNavigate();
  const location = useLocation();
  const { refresh } = useSession();
  const [token, setToken] = useState(params.get('token') ?? '');
  const email = (location.state as { email?: string } | null)?.email ?? '';

  const verify = useMutation<Record<string, unknown>, unknown>(routes.auth.verifyEmail);
  // TODO(api): there is no resend endpoint in §10.4, so the "send it again"
  // control is gone rather than pointed at a path that 404s. It needs
  // POST /api/v1/auth/verify-email/resend.

  return (
    <div className="narrow">
      <Card title="Verify your email">
        <p className="muted">
          {email ? `We sent a link to ${email}.` : 'Paste the code from the email we sent you.'}
        </p>
        <p className="muted">
          The link was sent once. If it did not arrive, check the address on your profile and get in
          touch — we cannot send it again from here yet.
        </p>
        <form
          onSubmit={async (e) => {
            e.preventDefault();
            const ok = await verify.run({ token });
            if (ok !== null) {
              await refresh();
              nav('/bots', { replace: true });
            }
          }}
        >
          <Field id="verify-token" label="Verification code">
            <input
              id="verify-token"
              className="input"
              required
              value={token}
              onChange={(e) => setToken(e.target.value)}
            />
          </Field>
          {verify.problem ? <InlineError problem={verify.problem} /> : null}
          <button type="submit" className="btn btn-primary" disabled={verify.pending}>
            {verify.pending ? 'Verifying…' : 'Verify'}
          </button>
        </form>
      </Card>
    </div>
  );
}
